module.exports = __webpack_public_path__ + "static/blog-1-1-acc6d1675d3fda684b54f3ad4ef3aafc.jpg";